import type { components } from '@/types/apiSchema';

type OperatingMode = components['schemas']['OperatingMode'];

interface PrescreenCompletionMessageParams {
  operatingMode: OperatingMode;
  companyName: string;
  recruiterFirstName: string;
}

export function shouldShowPrescreenMeetingLink(
  operatingMode: OperatingMode,
  meetingUrl: string | null | undefined,
): boolean {
  return !isSelfServiceOperatingMode(operatingMode) && Boolean(meetingUrl);
}

export function isSelfServiceOperatingMode(
  operatingMode: OperatingMode,
): boolean {
  return operatingMode === 'SelfService';
}

export function getSelfServiceHiringTeamName(companyName: string): string {
  return `${companyName.trim()} hiring team`;
}

export function getPrescreenCompletionMessage({
  operatingMode,
  companyName,
  recruiterFirstName,
}: PrescreenCompletionMessageParams): string {
  if (isSelfServiceOperatingMode(operatingMode)) {
    return `${getSelfServiceHiringTeamName(companyName)} will review your voice intro.`;
  }

  return `${recruiterFirstName} will connect with the hiring manager and reach out within 24 hours.`;
}
